import React from "react";
import { useFormik } from "formik";
import { Button } from "primereact/button";

import useWaitlist from "../../hooks/useWaitlist";
import _ from 'lodash'

const ProWaitlistFilter = ({toggleFilter})=>{
    const { data:{ filter }, actions:{ SetFilter, ResetFilter } } = useWaitlist({refresh:false});

    const formik = useFormik({
        initialValues: filter,
        validate: (data) => { },
        onSubmit: (data) => {
            toggleFilter(false);
            SetFilter(data);
        },
    });

    const hasFilter = () => {
        return _.drop(_.valuesIn(formik.values)).some(filter => !_.isEmpty(filter))
    }

    const onReset = () => {
        ResetFilter();
        toggleFilter(false);
        formik.resetForm();
    }

    return <form onSubmit={formik.handleSubmit}>
    <div className="p-grid p-justify-between">
        <div className="p-col-2">           
        </div>
        <div className="p-col-2">           
        </div>
        <div className="p-col-2">           
        </div>  
    </div>
    <div className="p-grid">
        <div className="p-col p-col-align-start">
            <span onClick={() => toggleFilter()} className="filter-collapse"><i className="fas fa-angle-up" style={{ color: '#6186ba', fontSize: 15 }}></i> Collapse</span>
        </div>
        <div className="p-col p-col-align-end button-text-align-right">
            <Button label="Reset" type="reset" onClick={onReset} className="p-button-text p-button-plain" />
            <Button label="Apply" type="submit" className={hasFilter() ? "p-button-text" : "p-button-text p-disabled"} />
        </div>
    </div>
</form>
}

export default ProWaitlistFilter